module.exports = __webpack_public_path__ + "img/34.44649565.png";